//引入封装好的 service
import service from "@/service/service";
import { nameToNumeric } from "@/utils";

//声明一个基础接口变量
const baseURL = `${import.meta.env.VITE_APP_STARNEST_API}/app-api/`;
const h5URL = `${import.meta.env.VITE_APP_STARNEST_API}/`;
const baseAdminURL = `${import.meta.env.VITE_APP_STARNEST_API}/admin-api/`;
const amaxNodeApi = `${import.meta.env.VITE_APP_URL}`;

//设置请求头（如果请求头统一的话可以在axios文件设置，则无须从这里传过去）
export const header = {
  Accept: 'application/json;charset=UTF-8',
}

const fileHeader = {
  Accept: 'multipart/form-data',
}

//根据自身需求
const _service={
    getNoticeDetail(data:any){
      const url = h5URL + `api/starnest/v1/index/notice_detail`
      return service.get(url, data, header);
    },
    getCaptcha(data:any){
      const url = baseAdminURL + `system/captcha/get`
      return service.post(url, data, header);
    },
    checkCaptcha(data:any){
      const url = baseAdminURL + `system/captcha/check`
      return service.post(url, data, header);
    },
   
    getAccountByPubKey(keys:any){
      const url = amaxNodeApi + `/v1/chain/get_accounts_by_authorizers`
      return service.post(url, {
        keys
      }, header);
    },
    getPubkeyByAccount(account_name:string){
      const url = amaxNodeApi + `/v1/chain/get_account`
      return service.post(url, {
        account_name
      }, header);
    },
    getTableRows(code:any,table:any){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code,
        scope: code,
        table: table,
        json: true,
      }, header);
    },
    getUserStake(accountName:any){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code:import.meta.env.VITE_APP_STAKE_NAME,
        scope:import.meta.env.VITE_APP_STAKE_NAME,
        table:'usrstake',
        key_type: "i64",
        lower_bound: accountName,
        upper_bound: accountName,
        json: true,
      }, header);
    },
    getBalanceByUser(data:any) {
      const url = amaxNodeApi + '/v1/chain/get_currency_balance'
      return service.post(url,data, header);
    },
    uploadImg(data:any) {
      const url = baseURL +`infra/file/upload`
      return service.post(url,data, header);
    },
    uploadOrderImg(data:any) {
      const url = baseURL +`infra/file/order/upload`
      return service.post(url,data, header);
    },
    getPayOrderDetail(params:any){
      const url = baseURL + `pay/order/get`
      return service.get(url, params, header);
    },
    getMallPay(){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code:import.meta.env.VITE_APP_PAY,
        scope: import.meta.env.VITE_APP_PAY,
        table: 'global',
        json: true,
      }, header);
    }
}

//导出
export default _service